<template>
  <div class="app">
    <nuxt />
  </div>
</template>

<script>
export default {
  name: "Login",
};
</script>
